import React, { useState, useEffect, useRef } from 'react';
import './SubscriptionExpired.css';

const SubscriptionExpired = () => {
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [extending, setExtending] = useState(false);

  const [loadError, setLoadError] = useState('');
  const mounted = useRef(true);
  const pending = useRef(false);

  useEffect(() => {
    mounted.current = true;
    fetchSubscriptionData();
    return () => { mounted.current = false; };
  }, []);

  const fetchSubscriptionData = async () => {
    setLoading(true);
    setLoadError('');
    try {
      const token = localStorage.getItem('token');
      const [infoResponse, pricingResponse] = await Promise.all([
        fetch('/api/subscription/user-info', { headers: { Authorization: `Bearer ${token}` } }),
        fetch('/api/subscription/pricing', { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      if (!infoResponse.ok || !pricingResponse.ok) throw new Error('load');
      const [info, pricing] = await Promise.all([infoResponse.json(), pricingResponse.json()]);
      if (!info.user || !info.subscription || !Array.isArray(pricing.plans)) throw new Error('format');
      if (mounted.current) {
        setSubscriptionData({subscription: info.subscription, pricing});
        setUserInfo(info.user);
      }
    } catch (error) {
      if (mounted.current) setLoadError('Не удалось загрузить подписку и тарифы. Попробуйте ещё раз.');
    } finally {
      if (mounted.current) setLoading(false);
    }
  };

  const extendSubscription = async (planId, months) => {
    if (pending.current) return;
    pending.current = true;
    setExtending(true);
    try {
      const response = await fetch('/api/subscription/extend', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}`},
        body: JSON.stringify({months, payment_method: 'card'})
      });
      if (!mounted.current) return;
      if (response.ok) {
        alert('Подписка успешно продлена!');
        window.location.href = '/dashboard';
      } else {
        alert(response.status === 401 ? 'Войдите в аккаунт заново для продления подписки' : 'Ошибка при продлении подписки');
      }
    } catch (error) {
      if (mounted.current) alert('Ошибка при продлении подписки');
    } finally {
      pending.current = false;
      if (mounted.current) setExtending(false);
    }
  };

  if (loading) {
    return (
      <div className="subscription-expired">
        <div className="loading">Загрузка...</div>
      </div>
    );
  }

  if (loadError || !subscriptionData || !userInfo) {
    return (
      <div className="subscription-expired">
        <div role="alert" className="error">{loadError || 'Ошибка загрузки данных'}</div>
        <button onClick={fetchSubscriptionData}>Повторить загрузку</button>
      </div>
    );
  }

  const { subscription, pricing } = subscriptionData;

  return (
    <div className="subscription-expired">
      <div className="container">
        <div className="header">
          <h1>🔒 Подписка истекла</h1>
          <p>Ваша подписка истекла и доступ к CRM системе заблокирован</p>
          <p>Для продолжения работы необходимо продлить подписку</p>
        </div>        <div className="user-info">
          <h2>👤 Информация о пользователе</h2>
          <p><strong>Имя:</strong> {userInfo.full_name || 'Не указано'}</p>
          <p><strong>Email:</strong> {userInfo.email}</p>
          <p><strong>Роль:</strong> {userInfo.role === 'founder' ? 'Основатель' : 'Сотрудник'}</p>
          <p><strong>Дата окончания подписки:</strong> {
            subscription.subscription_end_date
              ? new Date(subscription.subscription_end_date).toLocaleDateString('ru-RU')
              : 'Не указана'
          }</p>
          <p><strong>Статус:</strong> <span className="expired-status">❌ Подписка истекла</span></p>
        </div>

        <div className="pricing">
          <h2>💳 Выберите тариф для продления</h2>
          <div className="plans">
            {pricing.plans.map((plan) => (
              <div key={plan.id} className={`plan ${plan.recommended ? 'recommended' : ''}`}>
                {plan.recommended && <div className="badge">Рекомендуемый</div>}
                <h3>{plan.name}</h3>
                <div className="price">
                  <span className="amount">{plan.price}</span>
                  <span className="currency">{plan.currency}</span>
                  <span className="period">/ {plan.months} мес.</span>
                </div>
                {plan.discount && (
                  <div className="discount">Скидка {plan.discount}%</div>
                )}
                <ul className="features">
                  {plan.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
                <button
                  className="extend-btn"
                  onClick={() => extendSubscription(plan.id, plan.months)}
                  disabled={extending}
                >
                  {extending ? 'Обработка...' : `Продлить на ${plan.months} мес.`}
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="support">
          <p>Если у вас есть вопросы, обратитесь в службу поддержки</p>
          <p>Email: support@elentracrm.com | Телефон: +7 (800) 123-45-67</p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpired;
